import { combineReducers } from 'redux';

import error from 'modules/global/reducers/generic.error';
import loading from 'modules/global/reducers/generic.loading';
import { FIND_ONE_BY_NAME, FIND_ONE_BY_NAME_SUCCESS, } from 'modules/groups/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *   error: string,
 *   loading: boolean,
 *   data: {
 *     [groupName:string]: boolean
 *   },
 * }} GroupFindByNameReducer
 */

export default combineReducers({
  error: error(FIND_ONE_BY_NAME),
  loading: loading(FIND_ONE_BY_NAME),
  data: createReducer({}, {
    [FIND_ONE_BY_NAME_SUCCESS]: (state, { payload }) => ({
      ...state,
      [payload.name.toLowerCase()]: payload.found,
    }),
  }),
});
